import styled from "styled-components";

export const AuditLogCompanyMissionV2ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .show_loading {
    height: calc(100vh - 85px);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .content_section {
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    border-radius: 8px;
    min-height: calc(100vh - 235px);
    display: flex;
    padding: 24px 32px;
    flex-direction: column;
  }
  .date_range_row {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    margin: 20px 0;
  }

  .date_range_row .date_range_field {
    flex: 1;
    min-width: 140px;
    max-width: 216px;
  }

  .date_range_row .between_label {
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme }) => theme.COLORS.GRAY_26};
  }

  .table_section {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    > div {
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    .table_container {
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    .table_body {
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    .label_empty {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .pagination_section {
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    border-radius: 8px;
  }
`;
